export default "__VITE_ASSET__DJIucEyS__"